import { SET_DROPDOWN_ASYNC_OPTIONS } from 'root/src/client/logic/form/actionIds'

export default (moduleKey, items) => ({
	type: SET_DROPDOWN_ASYNC_OPTIONS,
	payload: { moduleKey, items },
})
